import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function DefenseServices() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">
              الخدمات
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">التسليح</span>
          </nav>
        </div>
      </div>

      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">التسليح والمعدات الدفاعية</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نوفر أحدث أنظمة التسليح والمعدات الدفاعية للجهات الحكومية والأمنية، 
              مع الالتزام الكامل بالضوابط التصديرية الدولية
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Service Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/6a7a7db63cdea1227330531510b75804.jfif"
                alt="التسليح والمعدات الدفاعية"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Service Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">نطاق خدماتنا</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">أنظمة مضادة للمسيرات</h3>
                    <p className="text-gray-600">أحدث التقنيات لكشف وتعطيل المسيرات غير المرخصة</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">درون المراقبة المتقدمة</h3>
                    <p className="text-gray-600">طائرات مسيرة للمراقبة والاستطلاع بتقنيات عالية الدقة</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">المركبات المصفحة</h3>
                    <p className="text-gray-600">مركبات مصفحة متطورة للحماية والنقل الآمن</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">أجهزة الكشف والتتبع</h3>
                    <p className="text-gray-600">أنظمة متقدمة للكشف والتتبع والمراقبة الأمنية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">التدريب والدعم الفني</h3>
                    <p className="text-gray-600">برامج تدريب شاملة ودعم فني متخصص للمعدات</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Standards Section */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">معايير الامتثال والترخيص</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">ضوابط التصدير</h3>
                <p className="text-gray-600">الالتزام الكامل بالضوابط التصديرية الدولية والمحلية</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">شهادة المستخدم النهائي</h3>
                <p className="text-gray-600">توثيق شامل لشهادات المستخدم النهائي EUC</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-government-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">ترخيص حكومي</h3>
                <p className="text-gray-600">جميع العمليات مرخصة من الجهات الحكومية المختصة</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">لماذا فيبا للتجارة؟</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-rocket-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">تقنيات متطورة</h3>
                <p className="text-gray-600">نوفر أحدث التقنيات الدفاعية من أفضل الشركات المصنعة عالمياً</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-star-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">امتثال كامل</h3>
                <p className="text-gray-600">التزام تام بجميع القوانين والضوابط المحلية والدولية</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">دعم مستمر</h3>
                <p className="text-gray-600">خدمة عملاء متخصصة ودعم فني مستمر لضمان الأداء الأمثل</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-[#E71B25] text-white p-12 rounded-2xl">
            <h2 className="text-3xl font-bold mb-6">تحتاج حلولاً دفاعية متقدمة؟</h2>
            <p className="text-xl mb-8 opacity-90">
              تواصل معنا للحصول على استشارة متخصصة حول احتياجاتك الأمنية والدفاعية
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] whitespace-nowrap"
              onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
            >
              طلب عرض سعر
              <i className="ri-mail-line mr-2"></i>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}